import axios from "axios";
import { useParams } from "react-router-dom";
import React, { useEffect, useRef, useState, useCallback } from "react";

import config from "./config";
import { useToast } from "./hooks/ToastContext";

import AnswerQuestion from "./Components/FeComponents/Feentry/AnswerQuestion";
import ChooseImage from "./Components/FeComponents/Feentry/ChooseImage";
import SingleChoice from "./Components/FeComponents/Feentry/SingleChoice";
import MultipleChoice from "./Components/FeComponents/Feentry/MultipleChoice";
import Facebook from "./Components/FeComponents/Feentry/Facebook";
import ShFacebook from "./Components/FeComponents/Feentry/ShFacebook";
import FeRegister from "./Components/FeComponents/FeRegister";
import VerifyPopup from "./Components/FeComponents/VerifyPopup";
import redirectTop from "./redirectTop";
import FeSignin from "./Components/FeComponents/FeSignin";
import YtWatchVideo from "./Components/FeComponents/Feentry/YtWatchVideo";
import YtSubmitVideo from "./Components/FeComponents/Feentry/YtSubmitVideo";
import ExternalPage from "./Components/FeComponents/Feentry/ExternalPage";
import YtSubscribeChannel from "./Components/FeComponents/Feentry/YtSubscribeChannel";
import ViralShare from "./Components/FeComponents/Feentry/ViralShare";
import CustomEntry from "./Components/FeComponents/Feentry/CustomEntry";
import Bonus from "./Components/FeComponents/Feentry/Bonus";
import Tweet from "./Components/FeComponents/Feentry/Tweet";
import Instagram from "./Components/FeComponents/Feentry/Instagram";
import TweetHashtag from "./Components/FeComponents/Feentry/TweetHashtag";
import CountdownTimer from "./Components/FeComponents/CountdownTimer";
import EntryIcon from "./Components/FeComponents/EntryIcon";
import MemberAchievement from "./Components/FeComponents/MemberAchievement";
import {
  ArrowRightStartOnRectangleIcon,
  UserCircleIcon,
} from "@heroicons/react/24/outline";
import SignupPageCTA from "./Components/FeComponents/SignupPageCTA";
import LoggedPageCTA from "./Components/FeComponents/LoggedPageCTA";
import ViralShareBox from "./Components/FeComponents/ViralShareBox";
import Badges from "./Components/FeComponents/Popups/Badges";
import Rewards from "./Components/FeComponents/Popups/Rewards";
import Leaderboard from "./Components/FeComponents/Popups/Leaderboard";
import PrizeSetup from "./Components/FeComponents/Popups/PrizeSetup";
import Terms from "./Components/FeComponents/Popups/Terms";
import RulesRegulation from "./Components/FeComponents/Popups/RulesRegulation";
import LoginAlert from "./Components/FeComponents/Popups/LoginAlert";
import EarnedPoints from "./Components/FeComponents/Popups/EarnedPoints";
import BadgeIcon from "./Icons/BadgeIcon";
import LearderboardIcon from "./Icons/LearderboardIcon";
import PlugIcon from "./Icons/PlugIcon";
import PrizeIcon from "./Icons/PrizeIcon";
import RewardIcon from "./Icons/RewardIcon";
import { ChevronUpIcon } from "@heroicons/react/24/solid";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import TickIcon from "./Icons/TickIcon";
import "./index.css"; // Import Tailwind styles
import ContestLoader from "./hooks/ContestLoader";
import ProfilePopup from "./Components/FeComponents/Popups/ProfilePopup";
import { getFingerprint, getFingerprintData } from "@thumbmarkjs/thumbmarkjs";
import { useCookies } from "react-cookie";
import { useLoader } from "./hooks/LoaderContext";
import FeQrCodePage from "./Components/FeComponents/FeQrCodePage";
import FeForgot from "./Components/FeForgot";

//import MetaTags from "./Components/Other_Components/MetaTags";
const FeContestPage = () => {
  const { cid } = useParams();

  const getIdFromMeta = () => {
    const meta = document.querySelector('meta[name="url"]');
    if (!meta) return null;

    const url = meta.getAttribute("content");
    return url?.split("/").pop(); // "av58e"
  };

  const id = cid ?? getIdFromMeta();
  const { showToast } = useToast();
  const [contestPageDetails, setcontestPageDetails] = useState({});
  const [contestDetails, setcontestDetails] = useState({});
  const [entrylist, setentrylist] = useState({});
  const [inputs, setInputs] = useState({});
  const [member, setMember] = useState({});
  const [showpage, setshowpage] = useState("contest");
  const [loginmode, setloginmode] = useState("register");
  const [signinEntry, setsigninEntry] = useState({});
  const [loading, setloading] = useState(0);
  const [activeEntry, setactiveEntry] = useState({});
  const [completedEntry, setcompletedEntry] = useState({});
  const [contestError, setcontestError] = useState(0);
  const [contestErrormsg, setcontestErrormsg] = useState(0);
  const [policyDetails, setPolicyDetails] = useState({});
  const [MemberAchievementDet, setMemberAchievementDet] = useState({});
  const topRef = useRef(null);
  const [enddateError, setenddateError] = useState(0);
  const [isRegistered, setIsRegistered] = useState(false);
  const [lang, setLanguage] = useState({});
  const [purl, setPurl] = useState("");
  const [mid, setMid] = useState(null);
  const [ffrefurl, setffrefurl] = useState("");
  const [dialogs, setDialogs] = useState({
    badges: false,
    rewards: false,
    leaderboard: false,
    prizesetup: false,
    terms: false,
    rulesregulation: false,
    loginalert: false,
    profile: false,
  });
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { showLoader, hideLoader } = useLoader();
  const [isRegLoading, setIsRegLoading] = useState(false);
  // Fallback for verify contests configured without a redirect url.
  const [verifyPopup, setVerifyPopup] = useState(null);
  const [removeBranding, setRemoveBranding] = useState(null);
  // const [visitorId, setVisitorId] = useState(null);
  const [Cookies, setCookie] = useCookies(["visitor_rand_id"]);
  // const [fecontestpage, setfecontestpage] = useState(false);
  //const [published_url, setpublished_url] = useState('');

  //const [msgError, setMsgError] = useState("");
  // const [metaKey, setMetaKey] = useState(0); // Force re-render key

  const memberdetails = sessionStorage.getItem("member_" + id);
  const parseMember = JSON.parse(memberdetails);

  const handleCloseDialog = (dialog) => {
    setDialogs((prevDialogs) => ({
      ...prevDialogs,
      [dialog]: false,
    }));
  };

  const handleDialogButtonClick = (dialog) => {
    if (memberdetails) {
      setDialogs((prevDialogs) => ({
        ...prevDialogs,
        [dialog]: true,
      }));
    } else {
      setDialogs((prevDialogs) => ({
        ...prevDialogs,
        loginalert: true,
      }));
    }
  };

  useEffect(() => {
    if (isOpen === dialogs.profile) {
      setIsOpen(false);
    }
  }, [dialogs.profile, isOpen]);

  const getMemberachievement = useCallback(
    async (contest_member_id = null) => {
      if (!contest_member_id) {
        const memberDet = JSON.parse(memberdetails);
        contest_member_id = memberDet.contest_member_id;
      }

      try {
        let payload = {
          contest_id: id,
          contest_member_id: contest_member_id,
        };
        const res = await axios.post(
          `${config.API_URL}/get-member-achievement-details`,
          payload,
        );
        if (res.status === 200) {
          setMemberAchievementDet(res.data);
        }
      } catch (error) {
        console.error(error);
      }
    },
    [id, memberdetails],
  );

  const feContestEntryList = useCallback(async () => {
    const session_member = sessionStorage.getItem("member_" + id);
    const memberDet = JSON.parse(session_member);
    try {
      let payload = {
        contest_id: id,
        contest_member_id: memberDet?.contest_member_id,
      };
      const res = await axios.post(
        `${config.API_URL}/get-fe-entry-list`,
        payload,
      );

      if (res.status === 200) {
        setentrylist(res.data.entrylist);
        if (res.data.active_entry) {
          setactiveEntry(res.data.active_entry);
        } else {
          //setcontestCompleteMsg('Contest Successfully Completed');
        }
        if (session_member) {
          setMember(JSON.parse(session_member));
        }
      }
    } catch (error) {
      console.log(error);
    }
  }, [id]);

  const feContestPageDetails = useCallback(async () => {
    try {
      const session_member = sessionStorage.getItem("member_" + id);
      // console.log(session_member);
      // console.log(id);

      if (id == "" || id == null) {
        return;
      }

      let payload = {
        contest_id: id,
        visitor_rand_id: Cookies.visitor_rand_id,
      };
      const res = await axios.post(
        `${config.API_URL}/get-fe-contest-details`,
        payload,
      );
      if (res.status === 200) {
        if (res.data.error) {
          setcontestError(1);
          setcontestErrormsg(res.data.msg);
          setactiveEntry({});
        } else {
          let contestdet = res.data.contest;
          if (contestdet.name) {
            document.title = contestdet.name;
          }
          setcontestDetails(res.data);
          setcontestPageDetails(JSON.parse(contestdet.contest_setup));
          if (contestdet.language) {
            setLanguage(JSON.parse(contestdet.language));
            //sessionStorage.setItem("lang_" + id, contestdet.language);
          }

          if (res.data.ff_refurl) {
            setffrefurl(res.data.ff_refurl);
          }

          if (contestdet.polices) {
            setPolicyDetails(JSON.parse(contestdet.polices));
          }
          handleGetRemoveBranding(contestdet.user_id);
          setsigninEntry(res.data.signin_entry);
          feContestEntryList();
          if (session_member) {
            getMemberachievement();
          }
          if (res.data.end_date_error || res.data.start_date_error) {
            setenddateError(res.data.end_date_error);
            setcontestErrormsg(res.data.msg);
          }
        }
        setTimeout(() => {
          setloading(1);
        }, 2000);
      }
    } catch (error) {
      console.log(error);
    }
  }, [id, getMemberachievement, feContestEntryList, Cookies]);

  const handleGetRemoveBranding = async (user_id) => {
    let payload = {
      contest_id: id,
      user_id: user_id,
      app_id: 7,
    };
    try {
      const res = await axios.post(
        `${config.API_URL}/get-branding-status`,
        payload,
      );
      if (res.status === 200) {
        // console.log(res.data);
        setRemoveBranding(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const clickEntryIcon = async (entry) => {
    if (memberdetails) {
      //setcontestCompleteMsg("");
      if (
        activeEntry.contest_entry_setting_id === entry.contest_entry_setting_id
      ) {
        setactiveEntry("");
      } else {
        setactiveEntry(entry);
      }
    } else {
      setDialogs((prevDialogs) => ({
        ...prevDialogs,
        loginalert: true,
      }));
    }
  };

  const saveMemberEntry = async () => {
    // setcontestCompleteMsg("");
    if (contestError === 0) {
      try {
        let payload = {
          contest_id: id,
          contest_member_id: member.contest_member_id,
          active_entry: activeEntry,
          entry: inputs,
          purl: purl,
        };
        const res = await axios.post(
          `${config.API_URL}/save-member-entry`,
          payload,
        );

        if (res.status === 200) {
          setInputs({});
          let contest_entry_setting_id = activeEntry.contest_entry_setting_id;

          const updatedData = entrylist.map((item) =>
            item.contest_entry_setting_id === contest_entry_setting_id
              ? { ...item, entry_status: 1 }
              : item,
          );
          setentrylist(updatedData);
          if (res.data.next_entry) {
            setactiveEntry(res.data.next_entry);
          } else if (res.data.viral_share_msg) {
            setactiveEntry({});
            //setcontestCompleteMsg(res.data.viral_share_msg);
          } else {
            setactiveEntry({});
            // setcontestCompleteMsg('Contest Successfully Completed');
          }
          getMemberachievement();
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const clickloginBtn = async (loginmode) => {
    setloginmode(loginmode);
  };
  const memberLogout = () => {
    sessionStorage.removeItem("member_" + id);
    setMember({});
    setloginmode("login");
    setactiveEntry({});
    const updatedData = entrylist.map((item) => ({ ...item, entry_status: 0 }));
    setentrylist(updatedData);
    setIsOpen(false);
  };

  const feSignin = async () => {
    showLoader();
    setIsRegLoading(true);
    try {
      let payload = {
        contest_id: id,
        email: typeof inputs?.email === "string" ? inputs.email.trim() : "",
        password:
          typeof inputs?.password === "string" ? inputs.password.trim() : "",
      };
      const res = await axios.post(`${config.API_URL}/contest-login`, payload);

      if (res.data.error) {
        showToast("error", lang?.invalid_login_credentials || res.data.msg);
        hideLoader();
        setIsRegLoading(false);
        return;
      } else if (res.status === 200) {
        if (res.data.member) {
          setInputs({});
          setMemberFn(res.data.member);
          //showToast("success", res.data.msg);
          showToast("success", lang?.successfully_logged_in || res.data.msg);
          topRef.current.scrollIntoView({ behavior: "smooth" });
        }
      }
    } catch (error) {
      console.log(error);
      hideLoader();
      setIsRegLoading(false);
    } finally {
      hideLoader();
      setIsRegLoading(false);
    }
  };

  const setMemberFn = useCallback(
    (memberdet) => {
      sessionStorage.setItem("member_" + id, JSON.stringify(memberdet));
      setMember(memberdet);
      feContestEntryList();
      getMemberachievement(memberdet.contest_member_id);
    },
    [id, feContestEntryList, getMemberachievement],
  );

  const CloseEntry = (entry) => {
    setcompletedEntry(entry);
    handleDialogButtonClick("earnedpoints");
  };

  const feRegister = async () => {
    showLoader();
    setIsRegLoading(true);
    const fingerprint = await getFingerprint();
    const fingerprintdata = await getFingerprintData();
    let visitorId;
    if (typeof fingerprint.visitorId !== "undefined") {
      //setVisitorId(fingerprint.visitorId);
      visitorId = fingerprint.visitorId;
    } else {
      // setVisitorId(fingerprint);
      visitorId = fingerprint;
    }
    // console.log(visitorId);

    // return;
    const urlParams = new URLSearchParams(window.location.search);
    const viralMemberId = urlParams.get("mid");
    try {
      let payload = {
        contest_id: id,
        name: typeof inputs?.name === "string" ? inputs.name.trim() : "",
        email: typeof inputs?.email === "string" ? inputs.email.trim() : "",
        phone: inputs?.phone,
        password:
          typeof inputs?.password === "string" ? inputs.password.trim() : "",
        confirm_password:
          typeof inputs?.confirm_password === "string"
            ? inputs.confirm_password.trim()
            : "",
        phone_status: inputs.phone_status,
        viralmemberid: mid ? mid : viralMemberId,
        visitor_id: visitorId,
        fingerprintdata: fingerprintdata,
      };
      const res = await axios.post(
        `${config.API_URL}/contest-register`,
        payload,
      );
      if (res.data.error) {
        showToast("error", res.data.msg);
        hideLoader();
        setIsRegLoading(false);
        return;
      } else if (res.data.ip_error) {
        showToast("error", res.data.msg);
        hideLoader();
        setIsRegLoading(false);
        return;
      } else if (res.status === 200) {
        if (res.data.member) {
          setInputs({});
          // Redirect contests show the success state briefly, then send
          // the whole page (not just the embed) to WhatsApp. No popup.
          if (res.data.verify?.redirect_url) {
            redirectTop(
              res.data.verify.redirect_url,
              res.data.verify.delay_seconds,
            );
          } else if (res.data.verify) {
            setVerifyPopup(res.data.verify);
          }
          setMemberFn(res.data.member);
          topRef.current.scrollIntoView({ behavior: "smooth" });
        }
      }
    } catch (error) {
      console.error(error);
      hideLoader();
      setIsRegLoading(false);
    } finally {
      hideLoader();
      setIsRegLoading(false);
    }
  };

  const autoRegister = useCallback(
    async (email, name, phone, mid = null, purlValue) => {
      const session_member = sessionStorage.getItem("member_" + id);
      if (!session_member) {
        //alert(mid);
        try {
          if (isRegistered) return;

          const fingerprint = await getFingerprint();
          const fingerprintdata = await getFingerprintData();
          let visitorId;
          if (typeof fingerprint.visitorId !== "undefined") {
            // setVisitorId(fingerprint.visitorId);
            visitorId = fingerprint.visitorId;
          } else {
            // setVisitorId(fingerprint);
            visitorId = fingerprint;
          }
          let payload = {
            contest_id: id,
            name: name,
            email: email,
            phone: phone,
            viralmemberid: mid,
            purl: purlValue,
            visitor_id: visitorId,
            fingerprintdata: fingerprintdata,
          };

          const res = await axios.post(
            `${config.API_URL}/contest-register`,
            payload,
          );

          if (res.data.error) {
            showToast("error", res.data.msg);
            return;
          } else if (res.status === 200) {
            if (res.data.member) {
              setInputs({}); // Clear inputs after registration
              // Redirect contests show the success state briefly, then send
              // the whole page (not just the embed) to WhatsApp. No popup.
              if (res.data.verify?.redirect_url) {
                redirectTop(
                  res.data.verify.redirect_url,
                  res.data.verify.delay_seconds,
                );
              } else if (res.data.verify) {
                setVerifyPopup(res.data.verify);
              }
              setMemberFn(res.data.member); // Update member
            }
          }
        } catch (error) {
          console.error(error);
        }
      }
    },
    [id, showToast, setMemberFn, isRegistered],
  );

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.type === "parent-url") {
        let ff_name, midValue, ff_email, ff_phone;
        console.log("Received Parent URL:", event.data.url);
        const parent_url = event.data.url;
        // const parent_url_new = parent_url;
        if (parent_url && parent_url !== "") {
          const parentUrl = new URL(parent_url);
          ff_email = parentUrl.searchParams.get("ff_email");
          if (!ff_email) {
            ff_email = parentUrl.searchParams.get("email");
          }

          if (
            ff_email !== "" &&
            ff_email !== null &&
            typeof ff_email !== "undefined"
          ) {
            //purlValue = parentUrl.searchParams.get("ff_refurl");
            ff_name = parentUrl.searchParams.get("ff_name");
            if (!ff_name) {
              ff_name = parentUrl.searchParams.get("name");
            }

            if (!ff_name && ff_email) {
              ff_name = ff_email.split("@")[0];
            }

            ff_email = decodeURIComponent(ff_email);
            //purlValue = decodeURIComponent(purlValue);
            ff_name = decodeURIComponent(ff_name);
          }

          if (!ff_name && ff_email) {
            ff_name = ff_email.split("@")[0];
          }

          ff_phone = parentUrl.searchParams.get("ff_phone");
          if (!ff_phone) {
            ff_phone = parentUrl.searchParams.get("phone");
          }

          // if ( purlValue !== "" &&  purlValue !== null &&  typeof purlValue !== "undefined"){
          //     setPurl(purlValue);
          // } else {
          //   const urlp = new URL(parent_url_new);
          //   const searchParams = urlp.searchParams;
          //   searchParams.delete("mid");
          //   const remove_mid_url = urlp.toString();
          //   setPurl(remove_mid_url);
          // }

          const urlp = new URL(parent_url);
          const searchParams = urlp.searchParams;
          searchParams.delete("mid");
          const remove_mid_url = urlp.toString();
          setPurl(remove_mid_url);

          midValue = parentUrl.searchParams.get("mid");
          if (
            midValue !== "" &&
            midValue !== null &&
            typeof midValue !== "undefined"
          ) {
            setMid(midValue);
          }

          if (
            ff_email !== "" &&
            ff_email !== null &&
            typeof ff_email !== "undefined"
          ) {
            setTimeout(() => {
              console.log("ff_email", ff_email);
              autoRegister(
                ff_email,
                ff_name,
                ff_phone,
                midValue,
                remove_mid_url,
              );
              setIsRegistered(true);
            }, 500);
          } else {
            return;
          }
        }
      }
    };

    window.parent.postMessage({ type: "get-parent-url" }, "*");
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [autoRegister, isRegistered]);

  useEffect(() => {
    const urlParamsqr = new URLSearchParams(window.location.search);
    const page = urlParamsqr.get("page");
    if (!page) {
      const visitor_rand_val = Math.random().toString(36).substring(2, 10);
      if (!Cookies.visitor_rand_id || Cookies.visitor_rand_id.trim() === "") {
        setCookie("visitor_rand_id", visitor_rand_val, {
          path: "/",
          maxAge: 3600,
        });
      }
      feContestPageDetails();
    } else if (page == "qr") {
      setshowpage("qr");
    }
  }, [feContestPageDetails, Cookies, setCookie]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      {showpage === "contest" ? (
        <>
          {loading === 1 ? (
            <>
              {contestError === 0 ? (
                <div ref={topRef} className="mx-auto bg-green-100 bodyBg">
                  <style>
                    {`
                  .primary_bg {
                    
                      background: ${contestPageDetails.primary_color};
                    
                  }
                  .primary_btn_bg {
                    
                      background: ${contestPageDetails.primary_color};
                      transition: background-color 0.3s ease;
                      border:1px solid ${contestPageDetails.primary_color} !important;
                  }
                  .profile_bg:hover {
                  background:${contestDetails.primary_light_color3} !important;
                  }

                  .primary_btn_bg:hover {
                      background: #fff;
                      color:${contestPageDetails.primary_color} !important;
                      border:1px solid ${contestPageDetails.primary_color} !important;
                  }
                  .primary_btn_bg:hover .icon-color-change {
                    color: ${contestPageDetails.primary_color} !important;
                  }
                  .earn_points_btn{
                      border:1px solid ${contestPageDetails.primary_color} !important;
                      color:${contestPageDetails.primary_color} !important;
                  }
                  .icons_bg {
                    
                      background: ${contestPageDetails.primary_color};
                      transition: background-color 0.3s ease;
                  }
                  .primary_text_color {
                    
                      color: ${contestPageDetails.primary_color};
                  }
                  .primary_border_color {
                    
                        border:1px solid ${contestPageDetails.primary_color} !important;
                  }
                  .primary_light_bgcolor {
                    
                        background:  ${contestDetails.primary_light_color2} !important;
                  }

                  .accordin_bgcolor {
                    
                        background:  ${contestDetails.primary_light_color2} !important;
                        border:1px solid ${contestDetails.primar_border_light_color} !important;
                  }
                  .primary_light_bgcolor2 {
                    
                        background:  ${contestDetails.primary_light_color2} !important;
                        
                  }   
                  .primary_light_bgcolor3 {
                    
                        background:  ${contestDetails.primary_light_color3} !important;
                        
                  }
                  .overlay_bg {
                      width: 100%;
                      height: 100%;
                      position: absolute;
                      background: #000000;
                      opacity: .8;
                      filter: alpha(opacity = 0.8);
                      z-index: 5;
                  }   
                  .overlay_bg_enddate {
                      width: 100%;
                      height: 89.8%;
                      position: absolute;
                      background: #000000;
                      opacity: .8;
                      filter: alpha(opacity = 0.8);
                      z-index: 5;
                      top:3%;
                  }      
                  .overlay_bg_text {
                      margin-top: 50%;
                      color: rgb(255, 255, 255);
                      font-size: 28px;
                      text-align: center;
                      padding: 0px 24px;
                  }        
                  .z-999 {
                      z-index: 999;
                  }   
                  .svg-fill-color {
                          color:${contestPageDetails.primary_color} !important;
                  }
                  .input_focus_primary:focus {
                          border-color: ${contestPageDetails.primary_color} !important;
                          box-shadow: 0 0 0 3px ${contestPageDetails.primary_color}40;
                  }   
                  .radio-primary:checked {
                    background-color: ${contestPageDetails.primary_color} !important;
                    border-color: ${contestPageDetails.primary_color} !important;
                  }
                  .radio-primary:focus {
                    outline: none;
                    box-shadow: 0 0 0 3px ${contestPageDetails.primary_color}50;
                    border-color: ${contestPageDetails.primary_color};
                  }
                `}
                  </style>
                  <style>
                    {contestPageDetails.bg_status === 1 &&
                      `
                  .bodyBg {
                        background: ${contestPageDetails.bg_color} !important;
                  }
              `}

                    {contestPageDetails.bg_status === 0 &&
                      (contestPageDetails.bg_size === "cover" ||
                        contestPageDetails.bg_size === "contain" ||
                        contestPageDetails.bg_size === "auto") &&
                      `
                    .bodyBg {
                          background-image: url(${contestPageDetails.bg_image}); 
                          background-size: ${contestPageDetails.bg_size};
                          background-position: center center;
                          background-repeat: no-repeat;
                              background-attachment: fixed;

                      }`}

                    {contestPageDetails.bg_status === 0 &&
                      (contestPageDetails.bg_size === "repeat" ||
                        contestPageDetails.bg_size === "no-repeat" ||
                        contestPageDetails.bg_size === "repeat-x" ||
                        contestPageDetails.bg_size === "repeat-y") &&
                      `
                    .bodyBg {
                          background-image: url(${contestPageDetails.bg_image}); 
                          background-repeat:  ${contestPageDetails.bg_size};
      
                      }`}

                    {enddateError === 1 &&
                      `
                  body {
                        overflow-y: auto !important;
                  }
              `}
                  </style>
                  {/* <style>
                    {`
                      @media (max-width: 768px) {
                        .footer {
                          position: fixed;
                          bottom: 0;
                          width: 100%;
                        }
                      }

                      @layer utilities {
                        @media (min-width: 769px) {
                          .pb-above-md-0 {
                            padding-bottom: 0 !important;
                          }
                        }
                      }

                    `}
                  </style> */}
                  <div
                    className={`max-w-[50rem] mx-auto  ${
                      contestDetails?.error === 1 ||
                      enddateError === 1 ||
                      contestDetails.start_date_error === 1
                        ? "relative"
                        : ""
                    }`}
                  >
                    {contestDetails.start_date_error === 1 && (
                      <div className="overlay_bg mx-auto">
                        <p className="overlay_bg_text">{contestErrormsg}</p>
                      </div>
                    )}

                    <div
                      className={`bg-white min-h-[100vh] flex flex-col ${
                        enddateError === 0 ? "max-h-[100vh]" : ""
                      }`}
                    >
                      <div
                        className={`flex-1 ${
                          enddateError === 0
                            ? "overflow-y-auto lg:scrollbar-custom scrollbar-custom relative"
                            : "relative"
                        }`}
                      >
                        {enddateError === 1 && member.contest_member_id && (
                          <div className="overlay_bg_enddate mx-auto">
                            <p className="overlay_bg_text">{contestErrormsg}</p>
                          </div>
                        )}
                        {/* Header */}
                        <header className="flex justify-between items-center px-4 shadow-md bg-white p-5">
                          <img
                            src={
                              contestPageDetails.bgLogo
                                ? contestPageDetails.bgLogo
                                : "https://img.flexifunnels.io/flexiviral-assets/logo-empty.png"
                            }
                            alt="logo"
                            className="fill-current text-gray-500 w-[100px] h-[50px] md:w-[200px] md:h-[50px]"
                          />

                          {/* {!member.contest_member_id && enddateError === 0 && (
                            <div>
                              {loginmode === "login" && (
                                <button
                                  onClick={() => clickloginBtn("register")}
                                  className="primary_btn_bg bg-[#0274F7] text-white w-[104px] h-[32px] rounded-md hover:bg-white hover:text-[#0274F7] border hover:border-[#0274F7]"
                                >
                                  {lang?.register || "Register"}
                                </button>
                              )}
                              {loginmode === "register" && (
                                <button
                                  onClick={() => clickloginBtn("login")}
                                  className="primary_btn_bg bg-[#0274F7] text-white w-[104px] h-[32px] rounded-md hover:bg-white hover:text-[#0274F7] border hover:border-[#0274F7]"
                                >
                                  {lang?.signin || "Sign In"}
                                </button>
                              )}
                            </div>
                          )}
                           */}
                          {!member.contest_member_id && (
                            <div>
                              {loginmode === "login" && (
                                <button
                                  onClick={() => clickloginBtn("register")}
                                  className="primary_btn_bg bg-[#0274F7] text-white w-[104px] h-[32px] rounded-md hover:bg-white hover:text-[#0274F7] border hover:border-[#0274F7]"
                                >
                                  {lang?.register || "Register"}
                                </button>
                              )}

                              {loginmode === "register" && (
                                <button
                                  onClick={() => clickloginBtn("login")}
                                  className="primary_btn_bg bg-[#0274F7] text-white w-[104px] h-[32px] rounded-md hover:bg-white hover:text-[#0274F7] border hover:border-[#0274F7]"
                                >
                                  {lang?.signin || "Sign In"}
                                </button>
                              )}
                            </div>
                          )}

                          {member.contest_member_id && (
                            // <button onClick={() => memberLogout()} className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-white hover:text-[#0274F7] border hover:border-[#0274F7]">
                            //     Logout
                            // </button>
                            <>
                              <div className="relative" ref={dropdownRef}>
                                <div className="flex items-center">
                                  <button
                                    onClick={() => setIsOpen(!isOpen)}
                                    className="primary_btn_bg flex items-center justify-center w-10 h-10 rounded-full bg-[#0274F7] border border-[#0274F7] hover:bg-white hover:text-[#0274F7] text-white font-bold"
                                  >
                                    {parseMember?.name.charAt(0).toUpperCase()}
                                  </button>
                                  <div className="ml-2">
                                    <p className="text-[12px] text-[#4D4D4D]">
                                      {lang?.welcome || "Welcome"}
                                    </p>
                                    <span className="text-[13px] text-black">
                                      {parseMember?.name}
                                    </span>
                                  </div>
                                </div>
                                {isOpen && (
                                  <div className="absolute right-0 mt-2 w-40 bg-white border rounded-lg shadow-lg z-999">
                                    {/* <div className="p-4 border-b">
                                                  <p className="text-sm text-gray-800">{parseMember?.name}</p>
                                              </div> */}
                                    <button
                                      onClick={() =>
                                        handleDialogButtonClick("profile")
                                      }
                                      className="primary_text_color profile_bg border-b flex items-center w-full text-left px-4 py-2"
                                    >
                                      <UserCircleIcon
                                        width={20}
                                        className="mr-2"
                                      />
                                      {lang?.profile || "Profile"}
                                    </button>
                                    <button
                                      onClick={() => memberLogout()}
                                      className="primary_text_color profile_bg flex items-center w-full text-left px-4 py-2 rounded-md"
                                    >
                                      <ArrowRightStartOnRectangleIcon
                                        width={20}
                                        className="mr-2"
                                      />
                                      {lang?.logout || "Logout"}
                                    </button>
                                  </div>
                                )}
                              </div>
                            </>
                          )}
                        </header>
                        {/* {enddateError === 1 && member.contest_member_id && (
                        <div className="overlay_bg_enddate mx-auto">
                        <p className="overlay_bg_text">{contestErrormsg}</p>
                        </div>
                        )} */}

                        <main className="relative flex-1">
                          {member.contest_member_id && (
                            <ViralShareBox
                              contest_id={id}
                              purl={purl}
                              ffrefurl={ffrefurl}
                              contestDetails={contestDetails}
                              lang={lang}
                            />
                          )}
                          {/* contest overview start*/}
                          {member.contest_member_id && (
                            <MemberAchievement
                              contest_id={id}
                              MemberAchievementDet={MemberAchievementDet}
                              lang={lang}
                            />
                          )}
                          {/* contest overview End*/}

                          {/* video  start*/}
                          <div className="flex flex-col items-center justify-center">
                            <div className="flex flex-col justify-center items-center w-full ">
                              {/* headline  start*/}
                              <div className="text-center text-[16px] leading-[24px] tracking-[0px] text-[#2C2C2C] opacity-100 py-4 px-4 font-normal">
                                <div
                                  className="mb-10"
                                  dangerouslySetInnerHTML={{
                                    __html: contestPageDetails?.headline,
                                  }}
                                />
                              </div>
                              {/* headline  start*/}

                              {/* <div className="w-96 border-[0.5px] border-[#CFCFCF] opacity-50 "></div> */}
                              <CountdownTimer
                                contestDetails={contestDetails}
                                setcontestError={setcontestError}
                                setcontestErrormsg={setcontestErrormsg}
                                setenddateError={setenddateError}
                                lang={lang}
                              />
                            </div>

                            {/* register form */}

                            <div
                              // className={`primary_light_bgcolor3 bg-[#F1F8FF] h-full w-full flex flex-col items-center justify-center mt-10 md:mt-0 p-5  ${
                              //   !member.contest_member_id ? "py-20" : "pb-10 pt-10"
                              // } ${contestPageDetails?.signup_image ? "pb-32" : ""} ${
                              //   contestDetails?.login_status === 0 ? "pb-0" : ""
                              // }`}
                              className={`primary_light_bgcolor3 bg-[#F1F8FF] h-full w-full flex flex-col items-center justify-center mt-10 md:mt-6 p-5 ${
                                !member?.contest_member_id &&
                                contestPageDetails.login_status === 1
                                  ? "py-10 pt-16"
                                  : "pt-20 pb-10"
                              } ${
                                contestPageDetails?.signup_image ? "pb-16" : ""
                              } ${!member.contest_member_id ? "my-16" : ""}`}
                            >
                              <div className="w-full max-w-[735px] md:w-[80%] lg:w-[735px]">
                                <SignupPageCTA
                                  contestPageDetails={contestPageDetails}
                                  contest_id={id}
                                  member={member}
                                />
                                <LoggedPageCTA
                                  contestPageDetails={contestPageDetails}
                                  contest_id={id}
                                  member={member}
                                />
                              </div>
                            </div>

                            {/* register form start */}

                            {!member.contest_member_id && (
                              <div>
                                {loginmode === "register" && (
                                  <FeRegister
                                    contestPageDetails={contestPageDetails}
                                    signinEntry={signinEntry}
                                    inputs={inputs}
                                    setInputs={setInputs}
                                    feRegister={feRegister}
                                    clickloginBtn={clickloginBtn}
                                    isRegLoading={isRegLoading}
                                    enddateError={enddateError}
                                    lang={lang}
                                  />
                                )}

                                {loginmode === "login" && (
                                  <FeSignin
                                    contestDetails={contestDetails}
                                    signinEntry={signinEntry}
                                    inputs={inputs}
                                    setInputs={setInputs}
                                    feSignin={feSignin}
                                    clickloginBtn={clickloginBtn}
                                    isRegLoading={isRegLoading}
                                  />
                                )}

                                {loginmode === "forgotpassword" && (
                                  <FeForgot
                                    contestDetails={contestDetails}
                                    // signinEntry={signinEntry}
                                    inputs={inputs}
                                    setInputs={setInputs}
                                    // feSignin={feSignin}
                                    clickloginBtn={clickloginBtn}
                                    // isRegLoading={isRegLoading}
                                  />
                                )}
                              </div>
                            )}

                            {/* {!member.contest_member_id ? (
                              <div>
                                {loginmode === "register" && (
                                  <FeRegister
                                    contestPageDetails={contestPageDetails}
                                    signinEntry={signinEntry}
                                    inputs={inputs}
                                    setInputs={setInputs}
                                    feRegister={feRegister}
                                    clickloginBtn={clickloginBtn}
                                    isRegLoading={isRegLoading}
                                    enddateError={enddateError}
                                    lang={lang}
                                  />
                                )}

                                {loginmode === "login" && (
                                  <FeSignin
                                    contestDetails={contestDetails}
                                    signinEntry={signinEntry}
                                    inputs={inputs}
                                    setInputs={setInputs}
                                    feSignin={feSignin}
                                    clickloginBtn={clickloginBtn}
                                    isRegLoading={isRegLoading}
                                  />
                                )}
                              </div>
                            ) : (
                              <div>
                                <ViralShareBox
                                  contest_id={id}
                                  purl={purl}
                                  ffrefurl={ffrefurl}
                                  contestDetails={contestDetails}
                                  lang={lang}
                                />
                              </div>
                            )} */}

                            {/* register form end */}
                          </div>
                          {/* video  End */}

                          {/* Giveway start */}
                          {contestPageDetails.desc_status === 1 && (
                            // <div className='bg-[#F1F8FF] flex flex-col items-center justify-center p-6 md:p-9'>
                            //     <div dangerouslySetInnerHTML={{ __html: contestPageDetails?.description }} />
                            // </div>
                            <div className="primary_light_bgcolor3 bg-[#F1F8FF] flex flex-col items-center justify-center p-6 md:p-9 mt-2">
                              <h2 className="text-center font-medium text-[17px] leading-[22px] text-black opacity-100 mb-4">
                                {lang?.why_participate || "Why Participate"}
                              </h2>

                              <div className="flex flex-col items-center justify-center bg-white rounded-sm p-5 md:p-6 md:w-full sm:w-[299px]">
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: contestPageDetails?.description,
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          {/* Giveway end */}
                          {/* accordion */}

                          {Array.isArray(entrylist) && entrylist.length > 0 && (
                            <div className="p-6 md:p-9 mb-5">
                              {member.contest_member_id && (
                                <h3 className="mb-3 text-center font-bold text-lg">
                                  {" "}
                                  {
                                    MemberAchievementDet?.member_complete_entry_woz
                                  }{" "}
                                  {lang?.entrires_to_complete ||
                                    "Entries to Complete"}
                                </h3>
                              )}

                              <div className="shadow-md mx-auto rounded-md">
                                <div className="">
                                  {/* Table Headers */}
                                  <div className="grid grid-cols-2 pt-3 font-semibold text-center text-sm sm:text-base">
                                    <div className="text-center md:mr-[150px] font-normal text-[14px] leading-[22px] text-black opacity-100">
                                      {lang?.entries || "Entries"}
                                    </div>
                                    <div className="text-center md:ml-[150px] font-normal text-[14px] leading-[22px] text-black opacity-100">
                                      {lang?.action || "Action"}
                                    </div>
                                  </div>

                                  {/* Goals List */}
                                  <div className="max-w-[648px] mx-auto p-4 bg-white rounded-md">
                                    {Array.isArray(entrylist) &&
                                    entrylist.length > 0 ? (
                                      entrylist.map((entry, index) => {
                                        const entrydet = JSON.parse(
                                          entry.entry,
                                        );
                                        return (
                                          <div key={index} className="mb-4">
                                            {/* Clickable Accordion */}
                                            <div className="accordin_bgcolor items-center w-full p-4 bg-[#F1F8FF] border border-[#7EBAFF] text-left rounded-md cursor-pointer">
                                              <div
                                                className="grid grid-cols-[auto,40px]"
                                                onClick={(e) => {
                                                  if (
                                                    entry.entry_status !== 1 ||
                                                    entry.type === "viralshare"
                                                  ) {
                                                    clickEntryIcon(entry);
                                                  } else {
                                                    CloseEntry(entry);
                                                  }
                                                }}
                                              >
                                                <div className="flex items-center gap-3">
                                                  <div className="primary_text_color primary_border_color p-2 rounded-full border  items-center justify-center hidden min-[321px]:block bg-white">
                                                    <EntryIcon entry={entry} />
                                                  </div>
                                                  <span className="text-left font-normal text-[12px] md:text-[15px] leading-[22px] text-black opacity-100">
                                                    {" "}
                                                    {entrydet.tooltip_text}
                                                  </span>
                                                </div>

                                                <div className="text-center items-center flex justify-end md:mr-5">
                                                  <div
                                                    className={`${
                                                      entry.entry_status === 1
                                                        ? ""
                                                        : "bordertese-l-2"
                                                    } pl-5`}
                                                  >
                                                    {entry.entry_status !==
                                                      1 && (
                                                      <span>
                                                        {activeEntry.contest_entry_setting_id ===
                                                        entry.contest_entry_setting_id ? (
                                                          <ChevronUpIcon
                                                            width={20}
                                                          />
                                                        ) : (
                                                          <ChevronDownIcon
                                                            width={20}
                                                          />
                                                        )}
                                                      </span>
                                                    )}
                                                    {entry.entry_status === 1 &&
                                                      entry.type !==
                                                        "viralshare" && (
                                                        <div className="flex items-center gap-1 md:gap-2">
                                                          <div
                                                            className={`md:p-3 p-2 rounded-full relative bg-[#34B52A]`}
                                                          >
                                                            <span className="absolute inset-0 flex items-center justify-center">
                                                              <TickIcon
                                                                className={
                                                                  "md:w-3 md:h-3 w-2 h-2"
                                                                }
                                                              />
                                                            </span>
                                                          </div>
                                                        </div>
                                                      )}
                                                  </div>
                                                </div>
                                              </div>

                                              {/* Expanded Section (Now Inside the Clickable Area) */}
                                              {entry.type ===
                                                "answerquestion" &&
                                                activeEntry.contest_entry_setting_id ===
                                                  entry.contest_entry_setting_id && (
                                                  <div
                                                    onClick={(e) =>
                                                      e.stopPropagation()
                                                    }
                                                    className="col-span-3 p-4 bg-[#FFFFFF] rounded-lg shadow-md mt-2  "
                                                  >
                                                    <AnswerQuestion
                                                      entryjson={activeEntry}
                                                      inputs={inputs}
                                                      setInputs={setInputs}
                                                      saveMemberEntry={
                                                        saveMemberEntry
                                                      }
                                                    />
                                                  </div>
                                                )}

                                              {entry.type === "singlechoice" &&
                                                activeEntry.contest_entry_setting_id ===
                                                  entry.contest_entry_setting_id && (
                                                  <div
                                                    onClick={(e) =>
                                                      e.stopPropagation()
                                                    }
                                                    className="col-span-3 p-4 bg-[#FFFFFF] rounded-lg shadow-md mt-2  "
                                                  >
                                                    <SingleChoice
                                                      entryjson={activeEntry}
                                                      inputs={inputs}
                                                      setInputs={setInputs}
                                                      saveMemberEntry={
                                                        saveMemberEntry
                                                      }
                                                    />
                                                  </div>
                                                )}

                                              {entry.type ===
                                                "multiplechoice" &&
                                                activeEntry.contest_entry_setting_id ===
                                                  entry.contest_entry_setting_id && (
                                                  <div
                                                    onClick={(e) =>
                                                      e.stopPropagation()
                                                    }
                                                    className="col-span-3 p-4 bg-[#FFFFFF] rounded-lg shadow-md mt-2  "
                                                  >
                                                    <MultipleChoice
                                                      entryjson={activeEntry}
                                                      inputs={inputs}
                                                      setInputs={setInputs}
                                                      saveMemberEntry={
                                                        saveMemberEntry
                                                      }
                                                    />
                                                  </div>
                                                )}

                                              {entry.type === "facebook" &&
                                                activeEntry.contest_entry_setting_id ===
                                                  entry.contest_entry_setting_id && (
                                                  <div
                                                    onClick={(e) =>
                                                      e.stopPropagation()
                                                    }
                                                    className="col-span-3 p-4 bg-[#FFFFFF] rounded-lg shadow-md mt-2  "
                                                  >
                                                    <Facebook
                                                      entryjson={activeEntry}
                                                      inputs={inputs}
                                                      setInputs={setInputs}
                                                      saveMemberEntry={
                                                        saveMemberEntry
                                                      }
                                                    />
                                                  </div>
                                                )}
                                              {entry.type === "chooseimage" &&
                                                activeEntry.contest_entry_setting_id ===
                                                  entry.contest_entry_setting_id && (
                                                  <div
                                                    onClick={(e) =>
                                                      e.stopPropagation()
                                                    }
                                                    className="col-span-3 p-4 bg-[#FFFFFF] rounded-lg shadow-md mt-2  "
                                                  >
                                                    <ChooseImage
                                                      entryjson={activeEntry}
                                                      inputs={inputs}
                                                      setInputs={setInputs}
                                                      saveMemberEntry={
                                                        saveMemberEntry
                                                      }
                                                      contestPageDetails={
                                                        contestPageDetails
                                                      }
                                                    />
                                                  </div>
                                                )}

                                              {entry.type === "ytwatchvideo" &&
                                                activeEntry.contest_entry_setting_id ===
                                                  entry.contest_entry_setting_id && (
                                                  <div
                                                    onClick={(e) =>
                                                      e.stopPropagation()
                                                    }
                                                    className="col-span-3 p-4 bg-[#FFFFFF] rounded-lg shadow-md mt-2  "
                                                  >
                                                    <YtWatchVideo
                                                      entryjson={activeEntry}
                                                      inputs={inputs}
                                                      setInputs={setInputs}
                                                      saveMemberEntry={
                                                        saveMemberEntry
                                                      }
                                                    />
                                                  </div>
                                                )}
                                              {entry.type === "ytsubmitvideo" &&
                                                activeEntry.contest_entry_setting_id ===
                                                  entry.contest_entry_setting_id && (
                                                  <div
                                                    onClick={(e) =>
                                                      e.stopPropagation()
                                                    }
                                                    className="col-span-3 p-4 bg-[#FFFFFF] rounded-lg shadow-md mt-2  "
                                                  >
                                                    <YtSubmitVideo
                                                      entryjson={activeEntry}
                                                      inputs={inputs}
                                                      setInputs={setInputs}
                                                      saveMemberEntry={
                                                        saveMemberEntry
                                                      }
                                                    />
                                                  </div>
                                                )}
                                              {entry.type === "ytsubscribe" &&
                                                activeEntry.contest_entry_setting_id ===
                                                  entry.contest_entry_setting_id && (
                                                  <div
                                                    onClick={(e) =>
                                                      e.stopPropagation()
                                                    }
                                                    className="col-span-3 p-4 bg-[#FFFFFF] rounded-lg shadow-md mt-2  "
                                                  >
                                                    <YtSubscribeChannel
                                                      entryjson={activeEntry}
                                                      inputs={inputs}
                                                      setInputs={setInputs}
                                                      saveMemberEntry={
                                                        saveMemberEntry
                                                      }
                                                    />
                                                  </div>
                                                )}
                                              {entry.type === "viralshare" &&
                                                activeEntry.contest_entry_setting_id ===
                                                  entry.contest_entry_setting_id && (
                                                  <div
                                                    onClick={(e) =>
                                                      e.stopPropagation()
                                                    }
                                                    className="col-span-3 p-4 bg-[#FFFFFF] rounded-lg shadow-md mt-2  "
                                                  >
                                                    <ViralShare
                                                      entryjson={activeEntry}
                                                      inputs={inputs}
                                                      setInputs={setInputs}
                                                      saveMemberEntry={
                                                        saveMemberEntry
                                                      }
                                                      contest_id={id}
                                                      purl={purl}
                                                      ffrefurl={ffrefurl}
                                                      contestDetails={
                                                        contestDetails
                                                      }
                                                    />
                                                  </div>
                                                )}

                                              {entry.type === "customentry" &&
                                                activeEntry.contest_entry_setting_id ===
                                                  entry.contest_entry_setting_id && (
                                                  <div
                                                    onClick={(e) =>
                                                      e.stopPropagation()
                                                    }
                                                    className="col-span-3 p-4 bg-[#FFFFFF] rounded-lg shadow-md mt-2  "
                                                  >
                                                    <CustomEntry
                                                      entryjson={activeEntry}
                                                      inputs={inputs}
                                                      setInputs={setInputs}
                                                      saveMemberEntry={
                                                        saveMemberEntry
                                                      }
                                                    />
                                                  </div>
                                                )}

                                              {entry.type === "bonus" &&
                                                activeEntry.contest_entry_setting_id ===
                                                  entry.contest_entry_setting_id && (
                                                  <div
                                                    onClick={(e) =>
                                                      e.stopPropagation()
                                                    }
                                                    className="col-span-3 p-4 bg-[#FFFFFF] rounded-lg shadow-md mt-2  "
                                                  >
                                                    <Bonus
                                                      entryjson={activeEntry}
                                                      inputs={inputs}
                                                      setInputs={setInputs}
                                                      saveMemberEntry={
                                                        saveMemberEntry
                                                      }
                                                    />
                                                  </div>
                                                )}

                                              {entry.type === "tweet" &&
                                                activeEntry.contest_entry_setting_id ===
                                                  entry.contest_entry_setting_id && (
                                                  <div
                                                    onClick={(e) =>
                                                      e.stopPropagation()
                                                    }
                                                    className="col-span-3 p-4 bg-[#FFFFFF] rounded-lg shadow-md mt-2  "
                                                  >
                                                    <Tweet
                                                      entryjson={activeEntry}
                                                      inputs={inputs}
                                                      setInputs={setInputs}
                                                      saveMemberEntry={
                                                        saveMemberEntry
                                                      }
                                                    />
                                                  </div>
                                                )}

                                              {entry.type === "tweethashtag" &&
                                                activeEntry.contest_entry_setting_id ===
                                                  entry.contest_entry_setting_id && (
                                                  <div
                                                    onClick={(e) =>
                                                      e.stopPropagation()
                                                    }
                                                    className="col-span-3 p-4 bg-[#FFFFFF] rounded-lg shadow-md mt-2  "
                                                  >
                                                    <TweetHashtag
                                                      entryjson={activeEntry}
                                                      inputs={inputs}
                                                      setInputs={setInputs}
                                                      saveMemberEntry={
                                                        saveMemberEntry
                                                      }
                                                    />
                                                  </div>
                                                )}

                                              {entry.type === "externalpage" &&
                                                activeEntry.contest_entry_setting_id ===
                                                  entry.contest_entry_setting_id && (
                                                  <div
                                                    onClick={(e) =>
                                                      e.stopPropagation()
                                                    }
                                                    className="col-span-3 p-4 bg-[#FFFFFF] rounded-lg shadow-md mt-2  "
                                                  >
                                                    <ExternalPage
                                                      entryjson={activeEntry}
                                                      inputs={inputs}
                                                      setInputs={setInputs}
                                                      saveMemberEntry={
                                                        saveMemberEntry
                                                      }
                                                    />
                                                  </div>
                                                )}

                                              {entry.type === "instagram" &&
                                                activeEntry.contest_entry_setting_id ===
                                                  entry.contest_entry_setting_id && (
                                                  <div
                                                    onClick={(e) =>
                                                      e.stopPropagation()
                                                    }
                                                    className="col-span-3 p-4 bg-[#FFFFFF] rounded-lg shadow-md mt-2  "
                                                  >
                                                    <Instagram
                                                      entryjson={activeEntry}
                                                      inputs={inputs}
                                                      setInputs={setInputs}
                                                      saveMemberEntry={
                                                        saveMemberEntry
                                                      }
                                                    />
                                                  </div>
                                                )}

                                              {(entry.type === "shfacebook" ||
                                                entry.type === "shx" ||
                                                entry.type === "shwhatsapp") &&
                                                activeEntry.contest_entry_setting_id ===
                                                  entry.contest_entry_setting_id && (
                                                  <div
                                                    onClick={(e) =>
                                                      e.stopPropagation()
                                                    }
                                                    className="col-span-3 p-4 bg-[#FFFFFF] rounded-lg shadow-md mt-2  "
                                                  >
                                                    <ShFacebook
                                                      entrytype={entry.type}
                                                      entryjson={activeEntry}
                                                      inputs={inputs}
                                                      setInputs={setInputs}
                                                      saveMemberEntry={
                                                        saveMemberEntry
                                                      }
                                                      contest_id={id}
                                                      purl={purl}
                                                      ffrefurl={ffrefurl}
                                                      contestDetails={
                                                        contestDetails
                                                      }
                                                    />
                                                  </div>
                                                )}
                                            </div>
                                          </div>
                                        );
                                      })
                                    ) : (
                                      <div></div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          <div className="bg-[#F1F8FF] p-6 md:p-9">
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mx-auto">
                              <button
                                type="button"
                                onClick={() =>
                                  handleDialogButtonClick("rewards")
                                }
                                className="primary_btn_bg bg-[#0274F7] px-4 py-2 rounded-md text-white text-[15px] leading-[22px] text-left flex items-center justify-center w-full hover:bg-white hover:text-[#0274F7] border hover:border-[#0274F7]"
                              >
                                <span className="mr-2">
                                  <RewardIcon width={15} height={15} />
                                </span>
                                {lang?.rewards || "Rewards"}
                              </button>
                              <button
                                type="button"
                                onClick={() =>
                                  handleDialogButtonClick("badges")
                                }
                                className="primary_btn_bg bg-[#0274F7] px-4 py-2 rounded-md text-white text-[15px] leading-[22px] text-left flex items-center justify-center w-full hover:bg-white hover:text-[#0274F7] border hover:border-[#0274F7]"
                              >
                                <span className="mr-2">
                                  <BadgeIcon width={20} height={20} />
                                </span>
                                {lang?.badges || "Badges"}
                              </button>
                              <button
                                type="button"
                                onClick={() =>
                                  handleDialogButtonClick("leaderboard")
                                }
                                className="primary_btn_bg bg-[#0274F7] px-4 py-2 rounded-md text-white text-[15px] leading-[22px] text-left flex items-center justify-center w-full hover:bg-white hover:text-[#0274F7] border hover:border-[#0274F7]"
                              >
                                <span className="mr-2">
                                  <LearderboardIcon width={15} height={15} />
                                </span>
                                {lang?.leaderboard || "Leaderboard"}
                              </button>
                              <button
                                type="button"
                                onClick={() =>
                                  handleDialogButtonClick("prizesetup")
                                }
                                className="primary_btn_bg bg-[#0274F7] px-4 py-2 rounded-md text-white text-[15px] leading-[22px] text-left flex items-center justify-center w-full hover:bg-white hover:text-[#0274F7] border hover:border-[#0274F7]"
                              >
                                <span className="mr-2">
                                  <PrizeIcon width={15} height={15} />
                                </span>
                                {lang?.prize || "Prize"}
                              </button>
                            </div>
                            <Badges
                              isOpen={dialogs.badges}
                              onClose={() => handleCloseDialog("badges")}
                              title={lang?.badges || "Badges"}
                              contest_id={id}
                              lang={lang}
                            />
                            <Rewards
                              isOpen={dialogs.rewards}
                              onClose={() => handleCloseDialog("rewards")}
                              title={lang?.rewards || "Rewards"}
                              contest_id={id}
                              lang={lang}
                            />
                            <Leaderboard
                              isOpen={dialogs.leaderboard}
                              onClose={() => handleCloseDialog("leaderboard")}
                              title={lang?.leaderboard || "Leaderboard"}
                              contest_id={id}
                              lang={lang}
                            />
                            <PrizeSetup
                              isOpen={dialogs.prizesetup}
                              onClose={() => handleCloseDialog("prizesetup")}
                              title={lang?.prize || "Prize"}
                              contest_id={id}
                              enddateError={enddateError}
                              contest_member_id={member.contest_member_id}
                              lang={lang}
                            />
                            <LoginAlert
                              isOpen={dialogs.loginalert}
                              onClose={() => handleCloseDialog("loginalert")}
                              title={
                                lang?.sign_in_required || "Sign-In Required"
                              }
                              lang={lang}
                            />
                            <EarnedPoints
                              isOpen={dialogs.earnedpoints}
                              onClose={() => handleCloseDialog("earnedpoints")}
                              title={lang?.earnedpoints || "Earned Points"}
                              entryjson={completedEntry}
                              lang={lang}
                            />
                            <ProfilePopup
                              isOpen={dialogs.profile}
                              onClose={() => handleCloseDialog("profile")}
                              title={lang?.my_profile || "My Profile"}
                              parseMember={parseMember}
                              setMember={setMember}
                              id={id}
                            />
                          </div>
                        </main>

                        {/* footer */}
                        <footer className="footer">
                          <div className="bg-[#F1F8FF] p-4 md:p-4 md:px-9 border">
                            <div className="flex justify-between">
                              <div className="flex gap-4 items-center">
                                {policyDetails?.terms_status === 1 && (
                                  <>
                                    <button
                                      onClick={() =>
                                        handleDialogButtonClick("terms")
                                      }
                                      className="text-center text-black text-[8px] md:text-[12px] leading-[23px] font-normal opacity-100 border-e-2 pr-4"
                                    >
                                      {lang?.terms_condition ||
                                        "Terms & Conditions"}
                                    </button>
                                    <Terms
                                      isOpen={dialogs.terms}
                                      onClose={() => handleCloseDialog("terms")}
                                      title={
                                        lang?.terms_condition ||
                                        "Terms & Conditions"
                                      }
                                      contestDetails={contestDetails}
                                    />
                                  </>
                                )}

                                {policyDetails?.rules_status === 1 && (
                                  <>
                                    <button
                                      onClick={() =>
                                        handleDialogButtonClick(
                                          "rulesregulation",
                                        )
                                      }
                                      className="text-center text-black text-[8px] md:text-[12px] leading-[23px] leading-[23px] font-normal opacity-100"
                                    >
                                      {lang?.rules_regualation ||
                                        "Rules & Regulations"}
                                    </button>
                                    <RulesRegulation
                                      isOpen={dialogs.rulesregulation}
                                      onClose={() =>
                                        handleCloseDialog("rulesregulation")
                                      }
                                      title={
                                        lang?.rules_regualation ||
                                        "Rules & Regulations"
                                      }
                                      contestDetails={contestDetails}
                                    />
                                  </>
                                )}
                              </div>
                              <div className="flex items-center justify-center">
                                {removeBranding?.branding === "inactive" && (
                                  <a
                                    href="https://flexifunnels.com"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="flex items-center"
                                  >
                                    <span className="mr-2">
                                      <PlugIcon />
                                    </span>
                                    <div className="flex items-center">
                                      <img
                                        src="https://img.flexifunnels.com/flexicontest/FlexiLogo.svg"
                                        alt="FlexiFunnels"
                                        className="mr-1 md:w-[18px] md:h-[18px] w-[15px] h-[15px]"
                                      />
                                      <span className="text-[10px] md:text-[12px]">
                                        FlexiFunnels
                                      </span>
                                    </div>
                                  </a>
                                )}
                              </div>
                            </div>
                          </div>
                        </footer>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center h-screen bg-[#F0FDF4]">
                  <img
                    src="https://assets.flexifunnels.com/images/ftcmsoon.png"
                    alt={contestErrormsg}
                    className="w-96"
                  />
                  <span className="text-[#2EB944] mt-10 text-4xl font-semibold">
                    {contestErrormsg}
                  </span>
                </div>
              )}
            </>
          ) : (
            <>
              <div className="flex flex-col items-center justify-center h-screen bg-[#F0FDF4] opacity-60 w-full">
                <div className="flex flex-col items-center w-full">
                  {/* <img
                  src="https://img.flexifunnels.com/flexicontest/FlexiLogo.svg"
                  alt={msgError}
                  className="w-10 h-10 md:w-20 md:h-20 mb-[80px] md:mb-[130px]"
                /> */}
                  <div className="w-16 h-16 md:w-10 md:h-10">
                    <ContestLoader />
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      ) : (
        <FeQrCodePage contest_id={id} />
      )}
      <VerifyPopup
        isOpen={!!verifyPopup}
        onClose={() => setVerifyPopup(null)}
        phone={verifyPopup?.phone}
        message={verifyPopup?.message}
      />
    </>
  );
};

export default FeContestPage;
